import axios from "../../interceptors/axiosInterceptor";
import {
  PAIYA_STORE_CSV_UPLOAD_URL,
  PAIYA_GIFT_CSV_UPLOAD_URL,
  PAIYA_SET_MOV_GAME_STATUS,
  PAIYA_GET_MOV_GAME_STATUS,
  FETCH_PAIYA_TYPE,
} from "../../config/Url";
import {
  IGetQueryParams,
  IPaiyaConfigCreationState,
  IPaiyaMOVGameStatusPayload,
  // IAddUpdatePaiyaPageState,
  IPaiyaTypeCategory,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import { normalizeCatchErrors } from "../../utils/errorUtils";
import { normalizePaiyaType } from "normalizer/PaiyaNormalizer";

export const fetchPaiyaTypeApiCall = () =>
  new Promise<any>((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    axios
      .get(FETCH_PAIYA_TYPE, requestConfig)
      .then((response) => {
        const data = response && response.data;
        resolve(normalizePaiyaType(data));
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createPaiyaStoreCsvApiCall = (
  gameVariantType: string,
  cityId: string,
  payload: FormData,
  url: string,
  queryParam: IGetQueryParams = {}
) =>
  new Promise<void>((resolve, reject) => {
    let requestConfig: any = getAuthOptions(true);
    requestConfig.params = queryParam;
    let url = PAIYA_STORE_CSV_UPLOAD_URL.replace(
      "{gameVariantType}",
      gameVariantType
    ).replace("{cityId}", cityId);
    axios
      .put(url, payload, requestConfig)
      .then((response) => {
        if (response) {
          resolve();
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createPaiyaGiftCsvApiCall = (
  gameVariantType: string,
  cityId: string,
  payload: FormData,
  url: string
) =>
  new Promise<void>((resolve, reject) => {
    let url = PAIYA_GIFT_CSV_UPLOAD_URL.replace(
      "{gameVariantType}",
      gameVariantType
    ).replace("{cityId}", cityId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => resolve())
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const fetchPaiyaConfigApiCall = (
  gameVariantType: string,
  cityId: string,
) =>
  new Promise<any>((resolve, reject) => {
    let url = PAIYA_GET_MOV_GAME_STATUS.replace(
      "{gameVariantType}",
      gameVariantType
    ).replace("{cityId}", cityId);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        const data = response && response.data;
        resolve(data);
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const createPaiyaMovGameStatusApiCall = (
  gameVariantType: string,
  cityId: string,
  payload: IPaiyaMOVGameStatusPayload,
) =>
  new Promise<void>((resolve, reject) => {
    let url = PAIYA_SET_MOV_GAME_STATUS.replace(
      "{gameVariantType}",
      gameVariantType
    ).replace("{cityId}", cityId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => resolve())
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
